<template>
    <h1>Administration</h1>
</template>
<script>
    export default {
        name: 'Admin'
    }
</script>